export default __webpack_public_path__ + "static/media/testimonials@3x.3fd2a265.png";